export enum DemoVideoTypes {
  OCF = 'ocf',
  PCF = 'pcf',
}
